import { useTranslation } from 'react-i18next';
import { locationCityLabel } from '~/pages/buy-lists/lib/locationLabel';
import { shipWeekLabel } from '~/pages/buy-lists/lib/shipWeekLabel';
import type { BuyListTarget } from './useMyOpenBuyLists';

type BuyListOptionListProps = {
  buyLists: BuyListTarget[];
  testId: string;
  headingId: string;
  onSelect: (buyList: BuyListTarget) => void;
};

export function BuyListOptionList({
  buyLists,
  testId,
  headingId,
  onSelect,
}: Readonly<BuyListOptionListProps>) {
  const { t } = useTranslation('inventory');

  return (
    <ul
      className="space-y-2"
      aria-labelledby={headingId}
      data-testid={`${testId}-section`}
    >
      {buyLists.map((buyList) => (
        <li key={buyList.id}>
          <button
            type="button"
            className="w-full flex items-center justify-between gap-4 px-4 py-3 border border-neut-200 rounded-lg text-sm text-left hover:border-prim hover:bg-emerald-50 transition-colors cursor-pointer"
            onClick={() => onSelect(buyList)}
            data-testid={`add-to-buy-list-option-${buyList.id}`}
          >
            <span className="flex min-w-0 flex-col gap-0.5">
              <span className="font-medium text-neut-900">
                {locationCityLabel(buyList.location)}
              </span>
              <span className="text-xs text-neut-sec">
                {shipWeekLabel(t, buyList.expectedShipDate)}
              </span>
            </span>
            <span className="text-neut-sec shrink-0">
              {t('inventory.buy_list.item_count', {
                count: buyList.items.length,
              })}
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
